import React from 'react'
import { Link } from 'react-router-dom'



const Containe = () => {
    return (
        <>

            <div className='containe'>

                <div className='contain2'>


                    <center><h4 className='headi'> FACILITES</h4></center>
                    <hr/>

                    <div className='alphabet'>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/About'> <span>A </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>B </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>C </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>D</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>E </span> </Link>
                        </div>
                    </div>


                    <div className='alphabet'>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>F</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/Surgery'> <span>G </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>H </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>I</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>J </span> </Link>
                        </div>
                    </div>

                    <div className='alphabet'>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>K </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>L</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>M</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>N</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>O </span> </Link>
                        </div>
                    </div>

                    <div className='alphabet'>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>P </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>Q</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>R </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>S</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>T </span> </Link>
                        </div>
                    </div>

                    <div className='alphabet'>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>U </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>V</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>W </span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>X</span> </Link>
                        </div>
                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>Y</span> </Link>
                        </div>
                    </div>



                    <div className='alphabet'>

                        <div className='alphabet2'>
                            <Link style={{ textDecoration: 'none' }} to='/'> <span>Z</span> </Link>
                        </div>

                       

                    </div>

                    


                </div>


                <div className='contain2'>

                    <center ><h4 className='headi'> TREATMENT</h4></center>

                    <hr/>

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} to='/Surgery'>  <span>General Surgery </span> <i class="fa fa-arrow-circle-o-right"></i></Link>
                    </div>

                    <hr />

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} to='/MaxillofacialSurgery'>  <span> Maxillofacial Surgery </span> <i class="fa fa-arrow-circle-o-right"></i></Link>
                    </div>

                    <hr />

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} to='/Neurologist'>  <span>Neurosurgery</span> <i class="fa fa-arrow-circle-o-right"></i></Link>
                    </div>

                    <hr />

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} to='/Ent'>  <span>Ear Nose Throat</span> <i class="fa fa-arrow-circle-o-right"></i></Link>
                    </div>

                    <hr />

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} to='/Urosurgery'>  <span>Uro Surgery</span> <i class="fa fa-arrow-circle-o-right"></i></Link>
                    </div>

                    <hr />

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} to='/Cardiology'>  <span>Cardiology</span> <i class="fa fa-arrow-circle-o-right"></i></Link>
                    </div>

                    <hr />

                    <div className='desse'>
                        <Link style={{ textDecoration: 'none' }} className="hover-effect" to='/Treatments'>
                            <span>View All Specialities</span>
                            <i className="fa fa-arrow-circle-o-right"></i>
                        </Link>
                    </div>



                </div>


            </div>


        </>
    )
}

export default Containe
